import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTImageToSDKImage } from '@wix/sdk-runtime/transformations/image';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { getCheckoutSettings as universalGetCheckoutSettings, updateCheckoutSettings as universalUpdateCheckoutSettings, } from './ecom-v1-checkout-settings-checkout-settings.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function getCheckoutSettings(httpClient) {
    return () => universalGetCheckoutSettings(
    // @ts-ignore
    { httpClient });
}
export function updateCheckoutSettings(httpClient) {
    return (checkoutSettings) => universalUpdateCheckoutSettings(checkoutSettings, 
    // @ts-ignore
    { httpClient });
}
export const onCheckoutSettingsUpdated = EventDefinition('wix.ecom.v1.checkout_settings_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTImageToSDKImage,
        paths: [{ path: 'entity.checkoutBrand.header.logo.image' }],
    },
])))();
export { Alignment, LogoSize, WebhookIdentityType, } from './ecom-v1-checkout-settings-checkout-settings.universal.js';
//# sourceMappingURL=ecom-v1-checkout-settings-checkout-settings.public.js.map